import styled from '@emotion/styled';
import { commonColors } from 'application/theme';

interface ItemStyledProps {
  isStrokeSvg?: boolean;
}

export const Wrapper = styled.article`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid ${commonColors.grey300};
  background: ${commonColors.white};
  box-shadow: 1px 1px 0 0 rgba(11, 37, 80, 0.17);

  > button {
    height: 36px;
    width: fit-content;
    svg {
      path {
        fill: ${commonColors.blue800};
      }
    }
  }
`;

export const ItemsList = styled.section`
  display: flex;
  flex-grow: 1;
  gap: 60px;

  > div {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 12px 8px;
    max-width: 50%;
  }
`;

export const ItemStyled = styled.div<ItemStyledProps>`
  display: flex;
  align-items: flex-start;

  span {
    color: ${commonColors.grey500};
    font-size: 16px;
    font-weight: 500;
    line-height: 22.4px;
    letter-spacing: 0.08px;
    margin: 0 6px 0 8px;
  }

  p {
    color: ${commonColors.grey700};
    font-size: 16px;
    font-weight: 500;
    line-height: 22.4px;
    letter-spacing: 0.08px;
    display: flex;
    align-items: flex-start;
    word-break: break-all;

    > span {
      display: block;
      white-space: nowrap;
    }
  }

  svg {
    min-width: 20px;
    height: 20px;

    path {
      fill: ${({ isStrokeSvg }) => (!isStrokeSvg ? commonColors.grey600 : '')};
      stroke: ${({ isStrokeSvg }) => (isStrokeSvg ? commonColors.grey600 : '')};
    }
  }
`;
